module.exports = __webpack_public_path__ + "static/media/HouseSmartLogoVertical.4c1d273c.svg";